<template>
  <base-step :title="trans('guided_search.capacity.title')" main-class="guided-search-content-form__capacity">
    <template #content>
      <div class="guided-search-content-form__capacity">
        <div class="general-tags capacity__tags">
          <TypeFormButton
            v-for="(tag, index) in capacityChoices"
            :key="index"
            :content="trans(tag.key, { min: tag.value.min, max: tag.value.max + 1 })"
            :active="tag.active"
            @clicked="selectTag(tag)"
          />
        </div>
      </div>
    </template>
  </base-step>
</template>

<script>
import TypeFormButton from '@components-molecules/TypeFormButton.vue';
import { guidedSearchMixin } from '@pages/guided-search/guidedSearchMixin';
import { capacityChoices } from '@pages/guided-search/guidedSearchEnum';
import BaseStep from './BaseStep.vue';

export default {
  name: 'Capacity',
  components: { TypeFormButton, BaseStep },
  mixins: [ guidedSearchMixin ],
  data() {
    return {
      capacityChoices,
    };
  },
  mounted() {
    window.dataLayer.push({
      event: 'screenChange',
      event_name: 'teamsize',
      step: 'teamsize',
      funnel: 'support-contact-form',
    });
  },
  methods: {
    selectTag(tag) {
      const actualValue = this.store.stepValues.capacity;
      const previousValue = actualValue;
      let storeValue = null;
      if (actualValue) {
        const oldIndex = this.capacityChoices.findIndex((t) => t.value === actualValue);
        this.capacityChoices[oldIndex].active = false;
      }
      if (actualValue !== tag.value) {
        const newIndex = this.capacityChoices.findIndex((t) => t.value === tag.value);
        this.capacityChoices[newIndex].active = true;
        storeValue = tag.value;
      }
      this.store.setStepValue({
        step: 'capacity',
        value: storeValue,
      });

      if (previousValue !== tag.value) {
        this.$emit('next-step');
      }
    },
  },
};
</script>
